<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.ADD_CHECK' | translate }}</h1>
  <mat-divider></mat-divider>

  @if (missingRequiredFields.length > 0) {
    <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
      <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
      <ul>
        @for (field of missingRequiredFields; track field.code) {
          <li>{{ field.label }}</li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions class="center">
      <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  } @else {
    <mat-stepper orientation="horizontal" [linear]="true">
      <ng-template matStepperIcon="edit">
        <i class="mdi mdi-check"></i>
      </ng-template>

      <mat-step [label]="'LABEL.CHECK_TYPE' | translate" [stepControl]="checkTypeForm">
        <mat-dialog-content class="fx-flex-auto fx-flex-offset-5">
          <mat-grid-list [cols]="getColCount()" [rowHeight]="'85px'">
            @for (checkType of checkTypes | async; track checkType; let i = $index) {
              <mat-grid-tile (click)="selectType(checkType)"
                             (keyup.enter)="selectType(checkType)"
                             [id]="'check_type_' + i"
                             [ngClass]="checkType.code === checkTypeForm.controls.checkType.value ? 'selected-type' : ''"
                             class="grid-tile"
                             tabindex="0">
                <div class="check-type-tile fx-justify-center fx-align-center">
                  <img [alt]="fileIconPath" [src]="fileIconPath"/>
                  <span class="check-type-label">{{ 'VALUE.' + checkType.code | uppercase | translate }}</span>
                </div>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </mat-dialog-content>

        <mat-dialog-actions>
          <button [id]="'check-type-btn-cancel'" mat-stroked-button matDialogClose="cancel">
            {{ 'BUTTON.CANCEL' | translate }}
          </button>
          <button [disabled]="!checkTypeForm.valid"
                  [id]="'check-type-next-button'"
                  color="accent"
                  mat-raised-button
                  matStepperNext>
            {{ 'BUTTON.NEXT' | translate }}
          </button>
        </mat-dialog-actions>
      </mat-step>

      <mat-step [label]="'LABEL.ASSET' | translate">
        <mat-dialog-content class="fx-flex-auto">
          <mat-form-field [formGroup]="checkSpaceForm" appearance="outline">
            <mat-label>{{ 'LABEL.ASSET' | translate }}</mat-label>
            <mat-select-asset-autocomplete formControlName="asset" required>
            </mat-select-asset-autocomplete>
            @if (checkSpaceForm.controls.asset.hasError('required')) {
              <mat-error>
                {{ 'ERROR.FIELD_REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>

          @if (assetTypeAllowsSpaceModule) {
            <div class="space-form-field">
              <ag-grid-angular
                (gridReady)="onGridReady($event)"
                [gridOptions]="gridOptions"
                [multiSortKey]="appConfig.GRID_MULTI_SORT_KEY"
                class="ag-theme-material"
                id="space-grid"

                style="width: 100%; height: 300px">
              </ag-grid-angular>
              @if (checkSpaceForm.controls.spaces.touched && checkSpaceForm.controls.spaces.hasError('required')) {
                <mat-error>
                  {{ 'ERROR.FIELD_REQUIRED'| translate }}
                </mat-error>
              }
              @if (checkSpaceForm.controls.spaces.hasError('incoherentSpaces')) {
                <mat-error>
                  {{ 'ERROR.SPACES_INCOHERENT' | translate }}
                </mat-error>
              }
            </div>
          }
        </mat-dialog-content>

        <mat-dialog-actions>
          <button [id]="'check-space-cancel-button'" mat-stroked-button matDialogClose="cancel">
            {{ 'BUTTON.CANCEL' | translate }}
          </button>
          <button [id]="'check-space-previous-button'" mat-stroked-button matStepperPrevious>
            {{ 'BUTTON.PREVIOUS' | translate }}
          </button>
          <button [disabled]="!checkSpaceForm.valid"
                  [id]="'check-btn-save'"
                  color="accent"
                  mat-raised-button
                  matDialogClose="yes">
            {{ 'BUTTON.ADD' | translate }}
          </button>
        </mat-dialog-actions>
      </mat-step>
    </mat-stepper>
  }
</div>
